import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListObject } from '../../../../../common/models/list.model';
import {
  convertGroupDatesToTimestampValues,
  getQueryStringFromObject,
  getTimestampWithTimezoneOffset,
  getTimezoneOffsetInHours,
} from '../../../../../common';
import { API_URL } from '../../../../../services/config';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { MasterDataEndpoint } from '../constants';
import { MasterDataBrief, MasterDataDateValues, MasterDataSearchOutput, MasterDataTimestampValues } from '../models';
import { startOfDay } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class MasterDataListService {
  constructor(private http: WrapperHttpService) {}

  getMasterDataList(searchOutput: MasterDataSearchOutput): Observable<ListObject<MasterDataBrief>> {
    const timezoneOffset: number = getTimezoneOffsetInHours(searchOutput.timezone);
    const { dateTimeRange, ...rest } = searchOutput.filter;

    const { start, end } = convertGroupDatesToTimestampValues<MasterDataDateValues, MasterDataTimestampValues>({
      dateTimeRange,
    }).dateTimeRange;

    const params = getQueryStringFromObject({
      ...rest,
      createdFrom:
        getTimestampWithTimezoneOffset(start, timezoneOffset) ??
        getTimestampWithTimezoneOffset(startOfDay(new Date()).getTime(), timezoneOffset),
      createdTo: getTimestampWithTimezoneOffset(end, timezoneOffset) ?? null,
    });

    const url = `${API_URL}${MasterDataEndpoint.Base}${MasterDataEndpoint.Find}?${params}`;
    return this.http.withLoading().get<ListObject<MasterDataBrief>>(url);
  }
}
